const browserPassiveWarnings = () => {
    $.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener('touchstart', handle, {
                passive: !ns.includes('noPreventDefault'),
            });
        },
    };

    $.event.special.touchmove = {
        setup: function (_, ns, handle) {
            this.addEventListener('touchmove', handle, {
                passive: !ns.includes('noPreventDefault'),
            });
        },
    };
};

module.exports = {
    browserPassiveWarnings,
};
